<template>
  <DriversList/>
</template>
<script>
import DriversList from '@/components/modules/schoolroutes/drivers/list'
export default {
  name: 'drivers',
  components: {
    DriversList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/drivers/list.vue